function collectCountdown(dateEnd, containerId, reload) {
  var timer, days, hours, minutes, seconds;

  dateEnd = new Date(dateEnd);
  dateEnd = new Date(
    dateEnd.getUTCFullYear(),
    dateEnd.getUTCMonth(),
    dateEnd.getUTCDate(),
    dateEnd.getUTCHours(),
    dateEnd.getUTCMinutes(),
    dateEnd.getUTCSeconds()
  );

  if ( isNaN(dateEnd) ) {
    return;
  }

  timer = setInterval(calculate, 1000);

  function calculate() {
    var dateStart = new Date();
    var dateStart = new Date(
      dateStart.getUTCFullYear(),
      dateStart.getUTCMonth(),
      dateStart.getUTCDate(),
      dateStart.getUTCHours(),
      dateStart.getUTCMinutes(),
      dateStart.getUTCSeconds()
    );
    var timeRemaining = parseInt((dateEnd - dateStart.getTime()) / 1000)
    var container = $(containerId)

    if ( timeRemaining >= 0 ) {
      days    = parseInt(timeRemaining / 86400);
      timeRemaining   = (timeRemaining % 86400);
      hours   = parseInt(timeRemaining / 3600);
      timeRemaining   = (timeRemaining % 3600);
      minutes = parseInt(timeRemaining / 60);
      timeRemaining   = (timeRemaining % 60);
      seconds = parseInt(timeRemaining);

      if (daysContainer = container.find('.days')) {
        daysContainer.html(days);
      }
      container.find('.hours').html(('0' + hours).slice(-2) + ' : ');
      container.find('.minutes').html(('0' + minutes).slice(-2) + ' : ');
      container.find('.seconds').html(('0' + seconds).slice(-2));
      container.removeClass('d-none');

    } else {
      if (reload === true) {
        $.ajax({
          type: 'GET',
          url: window.location.href,
          dataType : 'script'
        })
      }
      clearInterval(timer);
    }
  }

}

$(document).ready(function() {
  let countdownCollectContainer = $('#collectStartTimer')

  if (countdownCollectContainer.length > 0) {
    let dateEnd = countdownCollectContainer.data('starts-at');

    collectCountdown(dateEnd, '#collectStartTimer', false);
  }

  let countdownGroupContainer = $('#groupStartTimer')

  if (countdownGroupContainer.length > 0) {
    let dateEnd = countdownGroupContainer.data('starts-at');

    collectCountdown(dateEnd, '#groupStartTimer', true);
  }
})
